module.exports = __webpack_public_path__ + "ap.no2.b521c8d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ap.no2.jpg
// module id = P6TK
// module chunks = 0